/**
 * Mid-edge collapse/open tab for a side panel.
 *
 * Lives on the map-facing edge so it is not mistaken for a tab scroller.
 */
import React from 'react';
import { Box, Tooltip } from '@mui/material';

const GOLD = '#f5b942';

export const PanelEdgeTab: React.FC<{
  side: 'left' | 'right';
  title: string;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ side, title, onClick, children }) => (
  <Tooltip title={title} placement={side === 'left' ? 'right' : 'left'}>
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
      sx={{
        position: 'absolute',
        [side]: 0,
        top: '50%',
        transform: side === 'left' ? 'translate(-50%, -50%)' : 'translate(50%, -50%)',
        zIndex: 2,
        width: 18,
        height: 40,
        borderRadius: 1,
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer',
        color: 'text.secondary',
        '&:hover': { color: GOLD, borderColor: GOLD },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: GOLD,
          outlineOffset: 2,
        },
      }}
    >
      {children}
    </Box>
  </Tooltip>
);
